import { render, staticRenderFns } from "./ServicesItem.vue?vue&type=template&id=6c121cc6&scoped=true"
import script from "./ServicesItem.vue?vue&type=script&lang=js"
export * from "./ServicesItem.vue?vue&type=script&lang=js"
import style0 from "./ServicesItem.vue?vue&type=style&index=0&id=6c121cc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c121cc6",
  null
  
)

export default component.exports